// @flow

import { Button } from "../common";
import { MiniTicketCard } from "../cards";
import { Modulo, Text, Wrapper } from "./Notification.styles";
import { Walking } from "../icons";
import { pathOr } from "ramda";
import React, { useGlobal } from "reactn";
import theme from "views/resources/theme";
import type { Line, Office, Ticket } from "types";
import { getReservationCode } from "lib/helpers/reservation";
import { formatDatetime } from "lib/date";

interface Props {
	office: Office;
	line: Line;
	ticket: Ticket;
	call: Object;
	onClose(): void;
}

const Call = ({ office, line, ticket, call, onClose }: Props) => {
	const [reserves] = useGlobal("reserves");
	const color = "green";
	const modulo = /módulo/i.test(call.modulo) ? "" : "módulo";
	const isReservation = call && call.reserve;
	const reservationId =
		call && call.reserve_id
			? call.reserve_id
			: ticket && ticket.reserve && ticket.reserve._id;

	const currentReservation = reserves.find(
		(r) => r._id === `R${reservationId}` || r._id === reservationId
	);
	const reservationCode = getReservationCode(currentReservation);

	const reservationDate = formatDatetime(
		currentReservation && currentReservation.inserted_at,
		office.timezone
	);

	return (
		<Wrapper color={theme.icons[color]}>
			<Walking size={14} color={theme.icons.green} />
			<MiniTicketCard
				office={office}
				line={line.name ? line.name : line}
				ticket={ticket}
				notification={true}
				isReservation={isReservation}
				reservationId={reservationCode}
				reservationDate={reservationDate}
			/>
			{ticket.meet ? (
				<Text>¡Es tu turno!</Text>
			) : (
				<>
					<Text>Es tu turno, acércate al {modulo}</Text>
					<Modulo>{call?.modulo}</Modulo>
					<Text>Y muestra este ticket en tu teléfono</Text>
				</>
			)}
			<Button size={"full"} onClick={() => onClose()} gradient={color}>
				Entendido
			</Button>
		</Wrapper>
	);
};

export default Call;
